import React, { useState } from 'react';
import { List, Typography, Button, Col, Row, Modal } from 'antd';
import EditLeadLegumes from '../leadedit/editleadlegumes';
import {SettingOutlined} from '@ant-design/icons';
const { Title } = Typography;

const LeadLegumes = ({ dataLead, setIsInitialRender }) => {
    const [visible, setVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setIsInitialRender(true);
            setVisible(false);
            setConfirmLoading(false);
        }, 500);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    let legumes = JSON.parse(dataLead[0].legumes.split());
    return (
        <>
        <List
          size="small"
          header={
          <Row gutter={[24, 24]}>
            <Col span={21}>
              <Title level={5}>Les légumes que vous souhaitez inclure :</Title>
            </Col>
            <Col span={3}>
              <Button onClick={showModal} key="1" type="primary" shape="circle" icon={<SettingOutlined />} />
            </Col>
          </Row>}
          bordered
          dataSource={legumes}
          renderItem={(item) => <List.Item>{item}</List.Item>}
          />

        <Modal
            title="Les légumes que vous souhaitez inclure :"
            visible={visible}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={null}
        >
           <EditLeadLegumes dataLead={dataLead} handleOk={handleOk} handleCancel={handleCancel} confirmLoading={confirmLoading}/>
        </Modal>
        </>
        );
    }
    export default LeadLegumes;